import { Sentry } from '@quadralize/sentry'
import { Toaster, TooltipProvider } from '@quadralize/ui'
import { QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import type { PropsWithChildren } from 'react'
import { env } from '@/config/env'
import { GenericError } from '@/modules/error'
import { useAppStore } from '@/stores/use-app-store'
import { queryClient } from '@/utils/query-client'

export function Providers({ children }: PropsWithChildren) {
  const { theme } = useAppStore()

  return (
    <Sentry.ErrorBoundary fallback={<GenericError />} showDialog={false}>
      <QueryClientProvider client={queryClient}>
        <TooltipProvider>
          <Toaster theme={theme} />
          {children}
          {env.DEV && <ReactQueryDevtools initialIsOpen={false} buttonPosition="bottom-right" />}
        </TooltipProvider>
      </QueryClientProvider>
    </Sentry.ErrorBoundary>
  )
}
